import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { cancelFunctions } from 'utils/cancelFunctions';
import { fetchDirectSalesProduct } from 'modules/api/directSalesProductTemplate';
import { changeNewProduct, setProductLines } from 'store/productManagement/reducer';
import { ProductTemplateResponse } from 'components/common/types/DirectSalesProductTemplate.types';
import { getMarketId } from 'store/publisher/selectors';
import { transformOriginalProduct } from '../utils/transformOriginalProduct';

type UseApplyOriginalProduct = {
  applyProduct: (productId: string) => void;
};

const useApplyOriginalProduct = (): UseApplyOriginalProduct => {
  const dispatch = useDispatch();
  const marketId = useSelector(getMarketId);

  const fetchProductTemplate = async (productId: string): Promise<ProductTemplateResponse> => {
    try {
      return await fetchDirectSalesProduct(marketId, cancelFunctions, productId);
    } catch {
      return {} as ProductTemplateResponse;
    }
  };

  const applyProduct = async (productId: string): Promise<void> => {
    try {
      const originalProduct = await fetchProductTemplate(productId);

      if (isEmpty(originalProduct)) {
        return;
      }

      const { newProduct, productLines } = transformOriginalProduct(originalProduct);

      dispatch(setProductLines(productLines));
      dispatch(changeNewProduct(newProduct));
      // eslint-disable-next-line no-empty
    } catch {}
  };

  return {
    applyProduct,
  };
};

export default useApplyOriginalProduct;
